<template>
  <div class="user">
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="预售方案名称">
          <el-input v-model="formInline.title" placeholder="请输入预售方案名称"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="onSubmit()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="title" label="方案名称" width="240px"></el-table-column>
          <el-table-column prop="productName" label="预售产品">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic"><img v-img-url="scope.row.imagePath" alt=""/></div>
                <div class="info">
                  <div class="name">{{ scope.row.productName }}</div>
                  <div class="price">￥{{ scope.row.productPrice }}</div>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="orderNum" label="订单数量" width="100">
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="80">
            <template slot-scope="scope">
              <el-button @click="ItemClick(scope.row)" type="text" size="small">详情</el-button>
              <!--              <el-button @click="delClick(scope.row)" type="text" size="small">删除</el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
                       :current-page="curPage" :page-sizes="[2, 10, 20, 50, 100]" :page-size="pageSize"
                       layout="total, sizes, prev, pager, next, jumper" :total="totalDataNumber"></el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import OrderApi from '@/api/order.js'

export default {
  name: 'index',
  data () {
    return {
      /*横向表单数据模型*/
      formInline: {
        title: '',
      },
      tableData: [{}],
      loading: false,
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      /*获取列表*/
      this.getTableList()
    },
    /*搜索查询*/
    onSubmit () {
      let self = this
      let Params = this.formInline
      self.getTableList(Params)
    },
    /*选择第几页*/
    handleCurrentChange (val) {
      this.curPage = val
      this.getTableList()
    },

    /*每页多少条*/
    handleSizeChange (val) {
      this.curPage = 1
      this.pageSize = val
      this.getTableList()
    },
    /*获取列表*/
    getTableList (params = '') {
      let self = this
      let Params = {}
      self.arr = [0, 0, 0, 0]
      Params.status = self.status
      Params.pageIndex = self.curPage
      Params.pageSize = self.pageSize
      if (this.formInline.title) {
        Params.title = this.formInline.title
      }
      self.loading = true
      OrderApi.getPresaleList(Params, true)
        .then(res => {
          self.loading = false
          self.tableData = res.data.records
          self.totalDataNumber = res.data.total
        })
        .catch(error => {
        })
    },
    ItemClick (row) {
      this.$router.push({
        path: '/order/activity/orderlist/index',
        query: {
          activityId: row.activityId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/order/activity/presale/index.vue